import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
//import About from "./views/About.vue";
import Content from "./views/Content.vue";
import ContentElement from "./views/ContentElement.vue";
import Login from "./views/Login.vue";
import Module from "./views/Module.vue";
import Division from "./views/Division.vue";
import Centers from "./views/Centers.vue";
import Favorites from "./views/Favourites.vue";
import Providers from "./views/Providers.vue";
import Seminars from "./views/Seminars.vue";
import Tools from "./views/Tools.vue";
import Blog from "./views/Blog.vue";
import News from "./views/News.vue";
import Features from "./views/Features.vue";
import Sitemap from "./views/Sitemap.vue";
import InteractiveBlock from "./views/InteractiveBlock.vue";
import HtoolsContent from "./views/HtoolsContent.vue";
import Search from "./views/Search.vue";
import ThemeChooser from "./views/ThemeChooser.vue";
import LanguageChooser from "./views/LanguageChooser.vue";
import ErrorbLogin from "./views/ErrorbLogin.vue";
import NotFound from "./views/NotFound.vue";
import CompanyLogin from "./views/CompanyLogin.vue";
import CompanyChooser from "./views/CompanyChooser.vue";
import Forms from "./views/Forms.vue";
import CloudList from "./views/CloudList.vue";
import ProviderLocator from "./views/ProviderLocator.vue";
import ProviderLocatorMap from "./views/ProviderLocatorMap.vue";
import DirectContentDetail from "./views/DirectContentDetail.vue";
import CentersRedirect from "./views/CentersRedirect.vue";
import FeedBack from "./views/FeedBack.vue";
import Ssocallback from "./views/Ssocallback.vue";
import Ssoazurecallback from "./views/Ssoazurecallback.vue";
import Ssowsocallback from "./views/Ssowsocallback.vue";
import CosmicDivision from "./views/CosmicDivision.vue";
import ContentOnly from "./views/ContentOnly.vue";
import Ssowsologout from "./views/Ssowsologout.vue";
import Webinars from "./views/Webinars.vue";

import posthog from "posthog-js";

Vue.use(Router);

//export default new Router({
export const routes={
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
      // meta: {
      //   breadCrumbs: [{
      //     to: '/',            // hyperlink
      //     text: 'Home' // crumb text
      //   }]
      // }
    },
    { 
      path: '/index.html', 
      component: Home 
    },
    {
      path: "/content/:id",
      name: "Content",
      component: Content,
      query:{d:'',m:'',e:'',c:'',from:'',cd:''},
      meta:{breadCrumb:'ContentRootLevel'}
    },
    {
      path: "/content_element/:element_id",
      name: "ContentElement",
      component: ContentElement,
      query:{d:'',m:'',e:'',c:''},
      meta:{breadCrumb:'ContentElementRootLevel'}
    },
    {
      path: "/search/",
      name: "Search",
      component: Search,
      query:{q:'',type:''},
      meta:{breadCrumb:'SearchRootLevel'}
    },
   /* {
      path: "/module/:module_id/division/:division_id",
      name: "Module",
      component: Module
      
    },*/
    {
      path: "/module/:module_id",
      component: Module, name:"Module",
        meta:{breadCrumb:'ModuleRootLevel'}, 
      children:[
          { 
              path: 'division/:division_id?', component: Module, name:"Module",
              meta: {
                // breadCrumbs: [{
                //   to: '/module/:module_id/division/:division_id?', // hyperlink
                //   text: 'ModuleLevel0' // crumb text
                // }]
                breadCrumb: 'ModuleDivisionLevel'
              }
          },

          { 
              path: 'element/:element_id?', component: Module, name:"Module",
              meta:{
                breadCrumb: 'ModuleElementLevel'
              },
              children:[
                  {
                      path: 'division/:division_id?', component: Module, name:"Module",
                      meta: {breadCrumb: 'ModuleDivisionElementLevel'}
                  }
              ]
          },

          { 
              path: 'category/:category_id', component: Module, name:"Module",
              meta:{breadCrumb:'ModuleCategoryLevel'},
              children:[
                  {
                      path: 'division/:division_id?', component: Module, name:"Module",
                      meta:{breadCrumb:'ModuleDivisionCategoryLevel'}
                  },
                  { 
                      path: 'element/:element_id?', component: Module, name:"Module",
                      meta:{breadCrumb:'ModuleCategoryElementLevel'},
                      children:[
                        {
                            path: 'division/:division_id?', component: Module, name:"Module",
                            meta: {breadCrumb: 'ModuleDivisionCategoryElementLevel'}
                        }
                    ]
                  }
              ]
          }
        
      ]
    },

    {
      path: "/division/:division_id",
      name: "Division",
      component: Division
    },
    {
      path: "/centers/:center_id",
      name: "Centers",
      component: Centers,
      meta: {
        announcer: {
          skip: true
        },
        breadCrumb:'ContentRootLevel'
      }
    },
    {
      path: "/favorites",
      name: "Favorites",
      component: Favorites,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/feedback",
      name: "FeedBack",
      component: FeedBack,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/providers",
      name: "Providers",
      component: Providers,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/seminars",
      name: "Seminars",
      component: Seminars,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/webinars",
      name: "Webinars",
      component: Webinars,
      meta:{breadCrumb:'WebinarRootLevel'},
      query:{d:'',m:'',e:'',c:'',cd:''}
    },
    {
      path: "/tools",
      name: "Tools",
      component: Tools,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/news",
      name: "News",
      component: News,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/features",
      name: "Features",
      component: Features,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/sitemap",
      name: "Sitemap",
      component: Sitemap,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/cloudlist/:id_cloudword",
      name: "CloudList",
      component: CloudList,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/interactive_block/:interactive_id",
      name: "InteractiveBlock",
      component: InteractiveBlock,
      query:{d:'',m:'',e:'',c:''}
    },
    {
      path: "/blog",
      name: "Blog",
      component: Blog
    },
    {
      path: "/login/:company_id?/:token?/:redirect?",
      name: "Login",
      component: Login
    },
    {/* custom login with customfile */
      path: "/companylogin/:company_id/:file_name?",
      name: "CompanyLogin",
      component: CompanyLogin,
      query:{login_hint:''}
    },
    {/* custom login list cmpny */
      path: "/companychooser/:company_id/:file_name?",
      name: "CompanyChooser",
      component: CompanyChooser
    },
    {
      path: "/ssocallback/",
      name: "Ssocallback",
      component: Ssocallback
    },
    {
      path: "/ssoazurecallback/",
      name: "Ssoazurecallback",
      component: Ssoazurecallback
    },
    {
      path: "/ssowsocallback/",
      name: "Ssowsocallback",
      component: Ssowsocallback
    },
    {
      path: "/ssowsologout/",
      name: "Ssowsologout",
      component: Ssowsologout
    },
    {
      path: "/themechooser",
      name: "ThemeChooser",
      component: ThemeChooser
    },
    {
      path: "/languagechooser",
      name: "LanguageChooser",
      component: LanguageChooser
    },
    {
      path: "/htools_content/",
      name: "HtoolsContent",
      component: HtoolsContent,
      query:{type:'',d:'',m:'',e:'',c:'',element:''},/*type=category or content */
      meta:{breadCrumb:'htoolsContentLevel'}
    },
    {
      path: "/forms/:form_name",
      name: "Forms",
      component: Forms,
      query:{d:'',m:'',e:'',c:'',id:'',frmTyp:''},
      meta:{breadCrumb:'FormsRootLevel'}
    },
    {
      path: "/Err",
      name: "ErrorbLogin",
      component: ErrorbLogin
    },
    { 
      path: '*', 
      name:"NotFound",
      component: NotFound
    },
    {
      path: "/providerLocator/",
      name: "ProviderLocator",
      component: ProviderLocator,
      query:{pR:'',pT:'',pE:'',pC:'',pZ:'',pA:'',pS:'',pCnt:'',pCt:'',pRt:'',pG:''}
    },
    {
      path: "/providerLocatorMap/",
      name: "ProviderLocatorMap",
      component: ProviderLocatorMap,
      query:{gLa:'',gLo:'',gIm:'',gHe:'',gWi:'',gCi:''}
    },
    {
      path: "/content_detail/:id",
      name: "directContentDetail",
      component: DirectContentDetail,
      query:{d:'',m:'',e:'',c:'',from:''}
    },
    {
      path: "/center_redirect",
      name: "CentersRedirect",
      component: CentersRedirect,
      query:{d:'',m:'',e:'',c:'',surl:''}
    },
    {
      path: "/cosmicdiv/:cdivision_id",
      name: "CosmicDivision",
      component: CosmicDivision,
      meta:{breadCrumb:'CosmicDivisionLevel'}
    },
    {
      path: "/content_only/:id",
      name: "ContentOnly",
      component: ContentOnly,
      query:{d:'',m:'',e:'',c:'',from:''}
    }

  ]
};

const router = new Router(routes);
export default router;

router.afterEach( (to,from,next) => {
  Vue.nextTick(() => {
     posthog.capture("$pageview", {
       $current_url: to.fullPath
     });
  });
})


//{
  //path: "/about",
  //name: "about",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //component: () =>import(/* webpackChunkName: "about" */ "./views/About.vue")
//}